var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-agreement-detail"},[(_vm.config.htmlStr)?_c('div',{staticClass:"user-agreement-detail",domProps:{"innerHTML":_vm._s(_vm.config.htmlStr)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }